export default __webpack_public_path__ + "static/media/mock-exam.c3b4613b.svg";